const labels = () => ({
	"default": "en",
	"icon": {
		"arrowleft": "←",
		"arrowright": "→",
		"attach": "📄",
		"back": "◀︎",
		"cancel": "↖︎",
		"chat": "💬",
		"close": "✕",
		"create": "✚",
		"delete": "✕",
		"edit": "📝",
		"down": "▼",
		"down-alt": "▽",
		"forward": "▶︎",
		"injection": "🩼",
		"lock": "🔓",
		"network": "⇄",
		"ok": "✔︎",
		"pause": "||",
		"reload": "↺",
		"stop": "◼︎",
		"trash": "🗑️",
		"up": "▲",
		"up-alt": "△",
		"users": "\uD83D\uDC65",
		"wheel": "⚙️"
	},
	"it": {
		"About":"Informazioni",
		"AddToHomeBody": "Questa web application può essere installata direttamente come App nella Home del tuo dispositivo.",
		"AddToHomeBody2": "Puoi farlo ora automaticamente o manualmente scegliendo “Installa” dai Settings del browser.",
		"Ads":"Annunci",
		"Administrator": "Amministratore",
		"Calendar":"Calendario",
		"Cancel":"Annulla",
		"Carta e cartone": "Carta e cartone",
		"Click to live":"Click: dal vivo",
		"Contact developer":"Scrivi a Marco",
		"Dates": "Appuntamenti",
		"Day": "Giorno",
		"Delete":"Elimina",
		"Details":"Dettagli",
		"Directory":"Rubrica",
		"Drive directions": "Indicazioni stradali",
		"Edit":"Modifica",
		"Email":"E-mail",
		"Everyone on the web":"Chiunque sul web",
		"Expires on":"Scade in data",
		"Frutta e verdura": "Frutta e verdura",
		"Hide":"Nascondi",
		"Hours": "Ora",
		"humidity_percent": "umidità: {{value|0}}%",
		"Hum":"Umid",
		"Humidity":"Umidità",
		"Language": "Lingua",
		"link-default": "Link utili",
		"link-tech": "Link tecnici",
		"Links":"Link",
		"Management":"Gestione",
		"Moderation":"Moderazione",
		"Moderator":"Moderatore",
		"My ads":"I miei annunci",
		"Next dates": "Prossimi eventi",
		"New":"Nuovo",
		"No items found":"Nessun elemento trovato",
		"NoNotices": "Niente da segnalare",
		"NoWeeklyEvents": "Nessun evento in agenda",
		"Offering": "Offro",
		"Organico": "Organico",
		"Organico, Vetro": "Organico, Vetro",
		"Plastica e metallo": "Plastica e metallo",
		"Secco residuo/pannolini": "Secco residuo/pannolini",
		"Perceived": "Percepita",
		"Phonebook": "Rubrica",
		"Rain": "Pioggia",
		"Recycle": "Differenziata",
		"Recycling rules": "La raccolta differenziata",
		"Refresh":"Aggiorna",
		"Registered users":"Utenti autenticati",
		"Reload":"Ricarica",
		"Reply":"Rispondi",
		"ReportMessage":"Segnala questo messaggio come inappropriato",
		"ServiceTermsAccepted": "Comprendo e accetto i termini di servizio",
		"ServiceTermsRefused": "Non ho (ancora?) accettato i termini di servizio",
		"Remember me": "Ricordami",
		"Save":"Salva",
		"Subject":"Oggetto",
		"SunriseAt": "Sorge alle {{value}}",
		"SunsetAt": "Tramonta alle {{value}}",
		"Support": "Supporto",
		"Temperature": "Temperatura",
		"TemperatureAt": "La temperatura è di {{value}}°C",
		"Tomorrow": "Domani",
		"Traffic advisory": "Avvisi per la circolazione",
		"TrafficNoIssues": "Non sono segnalati problemi per la circolazione",
		"User":"Utente",
		"Vetro": "Vetro",
		"Verify email": "Verifica mail",
		"Wanted":"Cerco",
		"Weather forecasts": "Previsioni meteo",
		"Wind":"Vento"
	},
	"en": {
		"AddToHomeBody": "This web application can be conveniently installed as an App directly on your device Home screen.",
		"AddToHomeBody2": "You can install it now automatically, or later on by choosing “Install” in your browser settings.",
		"Carta e cartone": "Paper and cardboard",
		"Frutta e verdura": "Fruits and vegetables",
		"humidity_percent": "humidity: {{value|0}}%",
		"link-default": "Useful links",
		"link-tech": "Tecnical links",
		"NoNotices": "There aren’t notices",
		"NoWeeklyEvents": "No events in schedule",
		"Organico": "Organic waste",
		"Organico, Vetro": "Organic and Glass waste",
		"Plastica e metallo": "Plastic and aluminium",
		"Registered users":"Authenticated users",
		"ReportMessage":"Report an inappropriate message",
		"Secco residuo/pannolini": "Dry waste, diapers",
		"ServiceTermsAccepted": "I understand and accept the Terms of Service",
		"ServiceTermsRefused": "Terms of Service not accepted (yet?)",
		"SunriseAt": "Sunrise at {{value}} hs",
		"SunsetAt": "Sunset at {{value}} hs",
		"TemperatureAt": "Temperature is {{value}}°C",
		"TrafficNoIssues": "No traffic problems are reported",
		"Vetro": "Glass waste"
	}
});

export default labels;
